module.exports = __webpack_public_path__ + "img/loading-d-dots.e7c75a3d.gif";